const ENABLE_AUTH = process.env.REACT_APP_ENABLE_AUTH === 'true';

let configurePromise = null;
let authUiPromise = null;

export const isAuthEnabled = () => ENABLE_AUTH;

export const ensureAmplifyConfigured = async () => {
  if (!ENABLE_AUTH) {
    return null;
  }

  if (!configurePromise) {
    configurePromise = (async () => {
      const { Amplify } = await import('aws-amplify');
      Amplify.configure({
        Auth: {
          Cognito: {
            userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
            userPoolClientId: process.env.REACT_APP_COGNITO_APP_CLIENT_ID,
            loginWith: {
              email: true,
            },
          },
        },
      });
      return Amplify;
    })();
  }

  return configurePromise;
};

export const loadAmplifyAuth = async () => {
  if (!ENABLE_AUTH) {
    return null;
  }

  await ensureAmplifyConfigured();
  return import('aws-amplify/auth');
};

export const loadAmplifyUi = async () => {
  if (!ENABLE_AUTH) {
    return null;
  }

  if (!authUiPromise) {
    authUiPromise = (async () => {
      await ensureAmplifyConfigured();
      await import('@aws-amplify/ui-react/styles.css');
      return import('@aws-amplify/ui-react');
    })();
  }

  return authUiPromise;
};
